import { render, staticRenderFns } from "./CabeceraImagen.vue?vue&type=template&id=01c02c04"
import script from "./CabeceraImagen.vue?vue&type=script&lang=js"
export * from "./CabeceraImagen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports